// Text colours for proposed changes in the note and template assistants.
// The theme tokens alone don't work here: in dark mode --muted-foreground is
// as bright as the text, so removed and unchanged lines looked like added
// ones, and brand blue/red on their 10% tints fall below 4.5:1. Every pair
// below is at least 4.5:1 (WCAG AA) in both themes.
export const changeText = {
  // Diff rows (the coloured left border carries the meaning as well).
  addedLine:
    "border-success bg-success/10 dark:bg-success/20 dark:text-green-100",
  removedLine:
    "border-destructive bg-destructive/5 text-red-800 line-through dark:bg-destructive/20 dark:text-red-200",
  unchangedLine: "border-transparent text-muted-foreground dark:text-zinc-400",
  // Old value shown struck through next to the new one.
  before: "text-muted-foreground line-through dark:text-zinc-400",
  // Chips and labels.
  neutral: "bg-muted text-zinc-700 dark:bg-zinc-700 dark:text-zinc-100",
  changed: "bg-primary/10 text-sky-800 dark:bg-sky-400/15 dark:text-sky-200",
  danger: "bg-destructive/10 text-red-700 dark:bg-red-500/20 dark:text-red-200",
  dangerText: "text-red-700 dark:text-red-300",
  addedChip:
    "border-sky-700/30 bg-primary/10 text-sky-800 dark:border-sky-400/40 dark:bg-sky-400/15 dark:text-sky-200",
  removedChip:
    "border-dashed text-muted-foreground line-through dark:border-zinc-600 dark:text-zinc-400",
} as const;
